import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { BsCheckCircle, BsCircle } from 'react-icons/bs';
import { Label, Spacer } from '../../../atoms';
import '../form-item.scss';

export interface ListProps {
  answer: any,
  onAnswer: (vals: any) => void,
  withCheck?: boolean,
  multi?: boolean,
  option: any,
  editable?: boolean,
}

const List = (props: ListProps): JSX.Element => {
  const { answer, onAnswer, withCheck, option, multi, editable } = props;
  const [selected, setSelected] = useState(false);

  const classes = {
    'form-item__list': true,
    [`form-item__list--${selected}`]: true,
    [`form-item__list--${withCheck ? 'with-check' : 'no-check'}`]: true,
  };

  const labelClasses = {
    'form-item__list-label': true,
  };

  useEffect(() => {
    const someVarSoLinterSHUTSUP = 0;
    setSelected(answer.findIndex((it: any) => it?.label === option.label) !== -1);
  }, [answer, option.label]);


  const onClick = () => {
    if (!editable) {
      return;
    }
    if (multi) {
      const idx = answer.findIndex((it: any) => it?.label === option.label);
      if (idx === -1) {
        if (option?.action && option?.action === 'clear') {
          onAnswer([option]);
        } else {
          const idx2 = answer.findIndex((it: any) => it?.action === 'clear');
          if (idx2 !== -1) {
            onAnswer?.([option]);
          } else {
            onAnswer?.([...answer, option]);
          }

        }
      } else {
        const selection = [...answer];
        selection.splice(idx, 1);
        onAnswer(selection);
      }

    } else {
      onAnswer([option]);
    }
    setSelected(!selected);
  };


  return (
    <div >
      <Spacer value={5} />
      <div role='button' tabIndex={-1} onClick={onClick} className={classnames(classes)}>
        {withCheck && (selected ? <BsCheckCircle className='selected-icon' /> : <BsCircle />)}
        <div className={classnames(labelClasses)}>
          <Label size="h6" weight={200}  >{option?.label}</Label>
        </div>
      </div>
    </div>
  );
};

List.defaultProps = {
  withCheck: true,
  multi: false,
  editable: true,
};

List.displayName = 'List';
export default List;
